import axios from "axios"

const url = "/distributor/admin/api/v1/inventory/boxes"
export function getAllBoxesListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      dealer: parameters.dealer,
      filter: {
        products: parameters.filter.products,
        nodes: parameters.filter.nodes,
        search: parameters.filter.search,
        search_by: parameters.filter.search_by,
        created_at: parameters.filter.created_at,
        updated_at: parameters.filter.updated_at,
        located_at: parameters.filter.located_at,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}